import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import AnimatedImage from "../../components/AnimatedImage";
import SeoHead from "../../components/SeoHead";

export default function News() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/news").then(({ data }) => setItems(data)).catch(() => {}); }, []);

    return (
        <div data-testid="news-page">
            <SeoHead pageKey="news" />
            <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-12">
                <div className="text-xs uppercase tracking-[0.22em] text-muted-foreground mb-4">News, Stories & Impact</div>
                <h1 className="font-display text-5xl sm:text-6xl leading-[1.05] max-w-4xl mb-6">From the field. From the community. From the front lines.</h1>
            </section>

            <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                    {items.map((n, i) => (
                        <Link
                            to={`/news/${n.slug}`}
                            key={n.id}
                            className={`group block rounded-sm overflow-hidden border border-border bg-card hover:border-primary/60 transition-colors ${
                                i === 0 ? "lg:col-span-8" : "lg:col-span-4"
                            }`}
                            data-testid={`news-${n.slug}`}
                        >
                            <div className={`${i === 0 ? "aspect-[16/9]" : "aspect-[4/3]"}`}>
                                <AnimatedImage src={n.image_url} alt={n.title} className="w-full h-full" />
                            </div>
                            <div className="p-6">
                                <div className="flex items-center gap-3 text-xs uppercase tracking-[0.18em] mb-3">
                                    <span className="text-primary">{n.category}</span>
                                    <span className="text-muted-foreground">{n.author}</span>
                                </div>
                                <h3 className={`font-display ${i === 0 ? "text-3xl" : "text-xl"} mb-3 leading-tight group-hover:text-primary transition-colors`}>
                                    {n.title}
                                </h3>
                                <p className="text-sm text-muted-foreground line-clamp-3">{n.excerpt}</p>
                            </div>
                        </Link>
                    ))}
                </div>
                {items.length === 0 && <div className="text-center text-muted-foreground py-20">No stories yet.</div>}
            </section>
        </div>
    );
}
